import styled from 'styled-components'
import { FontFamilies, Message, pxToRem } from '../components'
import { Row } from '../components/Grid'
import colors from '../components/colors'

const TimeRow = styled(Row)`
  color: white;
  /* border-top: 1px solid white; */
  border-top: 1px solid ${colors.Entry.timeHeader.border};
  border-bottom: 1px solid ${colors.Entry.timeHeader.border};
  font-family: ${FontFamilies.RegularBold};
  padding: 0 4px;
  :first-child {
    margin-top: 0;
  }
  box-sizing: border-box;

  background-color: ${colors.Entry.timeHeader.background};
`

const SmallTime = styled.div`
  padding: 0.6rem;
  font-size: 1.3rem;
  font-family: ${FontFamilies.RegularBold};
  min-width: 4.5rem;
  text-transform: uppercase;
  text-align: left;
`

const SmallTimeRight = styled(SmallTime)`
  text-align: right;
`

const Time = styled.div`
  padding: 0.8rem 0.6rem;
  padding-top: 1.1rem;
  font-size: ${pxToRem(20)};
  flex: 1;
  text-align: center;
  font-family: ${FontFamilies.RegularBold};
  letter-spacing: 0.06em;
`

type Props = {
  from: string
  day: string
  withExtras?: boolean
}

const TimeHeader = ({ from, day, withExtras }: Props) => (
  <TimeRow>
    {withExtras && (
      <SmallTime>
        <Message id="DAY" data={day} />
      </SmallTime>
    )}

    <Time>{from}</Time>
    {withExtras && <SmallTimeRight> </SmallTimeRight>}
  </TimeRow>
)

export default TimeHeader
